
import React, { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    inquiryType: '',
    companyName: '',
    contactName: '',
    email: '',
    phone: '',
    content: '',
    agreePrivacy: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const inquiryTypes = [
    { value: 'interview', label: '取材' },
    { value: 'partnership', label: '共同事業' },
    { value: 'lecture', label: '講演依頼' },
    { value: 'recruit', label: '採用' },
    { value: 'other', label: 'その他' }
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.inquiryType || !formData.companyName || !formData.contactName || 
        !formData.email || !formData.content || !formData.agreePrivacy) {
      setSubmitMessage('必須項目をすべて入力してください。');
      return;
    }

    if (formData.content.length > 500) {
      setSubmitMessage('お問い合わせ内容は500文字以内で入力してください。');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const submitData = new FormData();
      submitData.append('inquiryType', formData.inquiryType);
      submitData.append('companyName', formData.companyName);
      submitData.append('contactName', formData.contactName);
      submitData.append('email', formData.email);
      submitData.append('phone', formData.phone);
      submitData.append('content', formData.content);
      submitData.append('agreePrivacy', formData.agreePrivacy.toString());

      const response = await fetch('https://readdy.ai/api/form/d35964q02086167cqoh0', {
        method: 'POST',
        body: submitData
      });

      if (response.ok) {
        setSubmitMessage('お問い合わせを送信いたしました。ありがとうございます。');
        setFormData({
          inquiryType: '',
          companyName: '',
          contactName: '',
          email: '',
          phone: '',
          content: '',
          agreePrivacy: false
        });
        
        setTimeout(() => {
          setSubmitMessage('');
        }, 3000);
      } else {
        setSubmitMessage('送信に失敗しました。しばらく時間をおいてから再度お試しください。');
      }
    } catch (error) {
      setSubmitMessage('送信に失敗しました。しばらく時間をおいてから再度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 md:py-32 bg-white mb-16 md:mb-32" id="contact">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12 md:mb-20">
            <p className="text-sm font-medium uppercase tracking-wider mb-6"
               style={{ color: 'rgb(11, 61, 145)' }}>
              CONTACT
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-8 md:mb-16 leading-relaxed">
              お問い合わせ
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-loose">
              お問い合わせやご相談は下記フォームよりお気軽にお送りください。<br />
              内容を確認の上、担当よりご連絡させていただきます。
            </p>
          </div>

          <form onSubmit={handleSubmit} data-readdy-form className="space-y-6 md:space-y-8">
            {/* お問い合わせ種別 */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-4">
                お問い合わせ種別 <span className="text-red-500">*</span>
              </label>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {inquiryTypes.map((type) => (
                  <label key={type.value} className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="inquiryType"
                      value={type.value}
                      checked={formData.inquiryType === type.value}
                      onChange={(e) => setFormData({...formData, inquiryType: e.target.value})}
                      className="mr-3"
                    />
                    <span className="text-sm text-[#111827]">{type.label}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {/* 会社名 */}
              <div>
                <label className="block text-sm font-medium text-[#111827] mb-3">
                  会社名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={(e) => setFormData({...formData, companyName: e.target.value})}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B3D91] focus:border-transparent text-sm"
                  placeholder="株式会社○○○"
                />
              </div>

              {/* ご担当者名 */}
              <div>
                <label className="block text-sm font-medium text-[#111827] mb-3">
                  ご担当者名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="contactName"
                  value={formData.contactName}
                  onChange={(e) => setFormData({...formData, contactName: e.target.value})}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B3D91] focus:border-transparent text-sm"
                  placeholder="山田 太郎"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {/* メールアドレス */}
              <div>
                <label className="block text-sm font-medium text-[#111827] mb-3">
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B3D91] focus:border-transparent text-sm"
                  placeholder="example@company.com"
                />
              </div>

              {/* 電話番号 */}
              <div>
                <label className="block text-sm font-medium text-[#111827] mb-3">
                  電話番号
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B3D91] focus:border-transparent text-sm"
                  placeholder="03-1234-5678"
                />
              </div>
            </div>

            {/* お問い合わせ内容 */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-3">
                お問い合わせ内容 <span className="text-red-500">*</span>
              </label>
              <textarea
                name="content"
                value={formData.content}
                onChange={(e) => setFormData({...formData, content: e.target.value})}
                rows={8}
                maxLength={500}
                className="w-full px-4 py-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B3D91] focus:border-transparent text-sm resize-none leading-loose"
                placeholder="具体的なご相談内容をお聞かせください（500文字以内）"
              />
              <p className="text-xs text-gray-500 mt-2">
                {formData.content.length}/500文字
              </p>
            </div>

            {/* プライバシーポリシー同意 */}
            <div>
              <label className="flex items-start cursor-pointer">
                <input
                  type="checkbox"
                  name="agreePrivacy"
                  checked={formData.agreePrivacy}
                  onChange={(e) => setFormData({...formData, agreePrivacy: e.target.checked})}
                  className="mt-1 mr-3"
                />
                <span className="text-sm text-[#111827] leading-relaxed">
                  プライバシーポリシーに同意します <span className="text-red-500">*</span>
                </span>
              </label>
            </div>

            {/* 送信ボタン */}
            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-full"
              size="lg"
            >
              {isSubmitting ? '送信中...' : 'お問い合わせを送信'}
            </Button>

            {/* メッセージ表示 */}
            {submitMessage && (
              <div className={`mt-6 p-4 rounded-lg text-sm leading-relaxed ${
                submitMessage.includes('ありがとう') || submitMessage.includes('送信いたしました')
                  ? 'bg-green-50 text-green-700 border border-green-200'
                  : 'bg-red-50 text-red-700 border border-red-200'
              }`}>
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}